import { render } from "./StockEdit.vue?vue&type=template&id=157c5f5b"
import script from "./StockEdit.vue?vue&type=script&lang=js"
export * from "./StockEdit.vue?vue&type=script&lang=js"

import "./StockEdit.vue?vue&type=style&index=0&id=157c5f5b&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__